export default __webpack_public_path__ + "static/media/werking-wheather-1.c2d7fc2a.JPG";